export interface UrlMetadata {
    image?: string;
    favicon?: string;
}

export interface UrlMetadataMap {
    [url: string]: UrlMetadata;
}

// Helper to validate if a string is a valid website URL
export const isValidWebsiteUrl = (url: string): boolean => {
    if (!url || typeof url !== 'string') return false;

    const trimmedUrl = url.trim();

    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
        try {
            new URL(trimmedUrl);
            return true;
        } catch {
            return false;
        }
    }

    return false;
};

// Helper to normalize URLs by ensuring they have a protocol
const normalizeUrl = (url: string): string => {
    if (!url?.trim()) return '';

    // If the URL doesn't start with http or https, prepend https://
    return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
};

// Helper to get domain favicon
export const getFaviconUrl = (websiteUrl: string): string => {
    if (!websiteUrl?.trim()) {
        return '';
    }
    try {
        // Ensure URL has a protocol
        const normalizedUrl = normalizeUrl(websiteUrl);
        const url = new URL(normalizedUrl);
        return `${url.protocol}//${url.hostname}/favicon.ico`;
    } catch (error) {
        console.warn(`Failed to parse URL for favicon: ${websiteUrl}`, error);
        return '';
    }
};

// Helper to get company logo from clearbit API (free, no authentication needed)
export const getCompanyLogo = (websiteUrl: string): string => {
    if (!websiteUrl?.trim()) {
        return '';
    }
    try {
        // Ensure URL has a protocol
        const normalizedUrl = normalizeUrl(websiteUrl);
        const url = new URL(normalizedUrl);
        return `https://logo.clearbit.com/${url.hostname}`;
    } catch (error) {
        console.warn(`Failed to generate company logo URL: ${websiteUrl}`, error);
        return '';
    }
};
